import React, { Component } from 'react'
import {
  Card,
  WhiteSpace,
  WingBlank,
  List,
  Modal,
  Toast,
  Button,
  TextareaItem,
} from 'antd-mobile'
import get from 'lodash/get'
import moment from 'moment'
import debounce from 'lodash/debounce'
import { getBlogs } from '../actions/queries'
import './styles/overwrite.css'

const Item = List.Item
const prompt = Modal.prompt
function closest(el, selector) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el
    }
    el = el.parentElement
  }
  return null
}
class Comment extends Component {
  state = {
    myQuestion: null,
    modal1: false,
    modal2: false,
    hadQuestion: false,
  }
  componentWillReceiveProps(props) {
    const theme = get(props, 'theme.theme.themes')
    let hadQuestion = false
    if (!props.theme.loading) {
      const themeTwo = theme[1]
      const patientId = get(this.props, 'match.params.patientId')
      const comments = themeTwo.comments
      for (const key in comments) {
        if (comments.hasOwnProperty(key)) {
          const comment = comments[key]
          if (comment.user._id === patientId) {
            hadQuestion = true
          }
        }
      }
      this.setState({ hadQuestion })
    }
  }
  showModal = key => e => {
    e.preventDefault() // 修复 Android 上点击穿透
    this.setState({
      [key]: true,
    })
    const mutate = this.props.clickQuestionButton
    const theme = get(this.props, 'theme.theme')
    const activityId = theme.themes[1]._id
    const patientId = get(this.props, 'match.params.patientId')
    const systemType = get(this.props, 'match.params.systemType', 'BG')
    const variables = {
      activityId,
      systemType,
      patientId,
      themeId: theme._id,
    }
    mutate({
      variables,
    })
      .then(res => {
        console.log('open question', res)
      })
      .catch(e => {
        console.log('catch a error', e)
      })
  }
  onClose = key => () => {
    this.setState({
      [key]: false,
    })
  }
  onWrapTouchStart = e => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return
    }
    const pNode = closest(e.target, '.am-modal-content')
    if (!pNode) {
      e.preventDefault()
    }
  }
  onChangeValue = value => {
    console.log('asd', value)
    this.setState({ myQuestion: value })
  }
  onSubmitQuetion = () => {
    const mutate = this.props.insertThemeComment
    const theme = get(this.props, 'theme.theme')
    const activityId = theme.themes[1]._id
    const patientId = get(this.props, 'match.params.patientId')
    const systemType = get(this.props, 'match.params.systemType', 'BG')
    const variables = {
      activityId,
      systemType,
      patientId,
      content: this.state.myQuestion,
    }
    console.log('variables', variables)
    mutate({
      variables,
      refetchQueries: [
        {
          query: getBlogs,
          variables: {
            themeId: theme._id,
            systemType,
          },
        },
      ],
    })
      .then(res => {
        this.setState({ modal2: true })
      })
      .catch(e => {
        console.log('catch a error', e)
      })
  }
  render() {
    const theme = get(this.props, 'theme.theme.themes')
    if (!this.props.theme.loading) {
      const themeTwo = theme[1]
      const comments = themeTwo.comments
      const patientId = get(this.props, 'match.params.patientId')
      const isShare = get(this.props, 'isShare', true)
      const commentElement = []

      return (
        <main style={{marginTop:'30px'}}>
          <WingBlank style={{ height: '10px' }} size="lg" />
          <Card full>
            <Card.Body>
              <div className="theme-button">
                <span>礼物二:提出问题 专家解惑 还有奖！</span>
              </div>
              <div>
                <div className="theme-title">
                  <h3 style={{ textAlign: 'center' }}>规则介绍</h3>
                </div>
                <div className="theme-radius-wrapper">
                    <div
                      className="comment-list"
                      style={{ color: '#584F62', padding: '15px 10px', flexDirection: 'column' }}
                    >
                      <div style={{paddingBottom: '20px'}}>
                        有奖征集糖友问题！专家给您解惑。问题“获赞数”排名前十的糖友将获得以下奖品：
                        </div>
                      <div>
                        1、共同照护门诊提供的旅行箱，或旅行背包。
                      </div>
                      <div>
                        <div style={{width: '60%', display: 'inline-block'}}>
                            <p>2、您的问答将被专家答疑，并在公众号、涨知识刊登。</p>
                            <p>3、每个用户只能提出一个问题呦~</p>
                        </div>
                        <div style={{width: '40%', display: 'inline-block'}}>
                            <img
                                src={require('./springImage/prize.png')}
                                style={{
                                    zIndex: '999',
                                    width: '100px',
                                    marginTop: '-40px',
                                    verticalAlign: 'inherit'}}
                            />
                        </div>
                      </div>
                      <div>问题将会于活动结束后，一周后刊登文章答复。请大家后续关注涨知识文章哟。</div>
                    </div>
                    {
                        !this.state.hadQuestion ? (
                            <div
                                style={{
                                    height: '60px',
                                    backgroundImage:
                                    'url(' + require('./springImage/button1.png') + ')',
                                    backgroundRepeat: 'round',
                                }}
                                onClick={this.showModal('modal1')}
                                />
                        ) : (<div
                                style={{
                                    height: '60px',
                                    backgroundImage:
                                    'url(' + require('./springImage/button2.png') + ')',
                                    backgroundRepeat: 'round',
                                }}
                                />)
                    }
                    <Modal
                      visible={this.state.modal1}
                      transparent
                      maskClosable={false}
                      onClose={this.onClose('modal1')}
                      title="填写问题"
                      footer={[
                        {
                          text: '取消',
                          onPress: () => {
                            this.onClose('modal1')()
                          },
                        },
                        {
                          text: '提交',
                          onPress: () => {
                            const str1 = this.state.myQuestion.replace(/\s/g, "")
                            if (str1.length > 0) {
                              this.onSubmitQuetion()
                            }
                            this.onClose('modal1')()
                          },
                        },
                      ]}
                      wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    >
                      <div style={{ height: 150, overflow: 'scroll' }}>
                        <TextareaItem
                          placeholder="请输入您的问题，我们会提供给您最专业的答复"
                          data-seed="logId"
                          ref={el => (this.autoFocusInst = el)}
                          autoHeight
                          onChange={this.onChangeValue}
                        />
                      </div>
                    </Modal>
                  </div>
                <Modal
                  visible={this.state.modal2}
                  transparent
                  maskClosable={true}
                  onClose={this.onClose('modal2')}
                  footer={[
                    {
                      text: '好的',
                      onPress: () => {
                        console.log('ok')
                        this.onClose('modal2')()
                      },
                    },
                  ]}
                  wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                >
                  <div style={{ height: 250, overflow: 'scroll' }}>
                    <img
                      src={require('./springImage/success.png')}
                      style={{
                        margin: '17.5px',
                        width: '80px',
                        height: '80px',
                      }}
                    />
                    <h3 style={{ textAlign: 'center' }}>提交成功</h3>
                    <h3 style={{ textAlign: 'center' }}>我们回尽快给您答复</h3>
                  </div>
                </Modal>
              </div>
            </Card.Body>
          </Card>
        </main>
      )
    } else {
      return <div />
    }
  }
}

export default Comment



// WEBPACK FOOTER //
// ./src/modules/theme/components/questionActivity.js